/**
 * Created by mmaillot on 7/20/16.
 */
import EQCore from './public-apis/EQCore'

export const instance = new EQCore();


// WEBPACK FOOTER //
// ./js/main.js